// extracted by mini-css-extract-plugin
export var container = "_bu-1";
export var cornerButtonContainer = "_bu-5";
export var disabled = "_bu-2";
export var fileContainer = "_bu-4";
export var hiddenInput = "_bu-3";
export var widthContainer = "_bu-0";